module.exports = __webpack_public_path__ + "img/logo.d57851c1.png";